export type ChatbotState = {
  status: 'DISABLED' | 'HIDDEN' | 'GIGA_CHAT_VISIBLE' | 'PROACTIVE_CHAT_VISIBLE';
  triggerType: string | null;
  proactiveModalViewed?: { [page: string]: boolean };
  gigaEventTriggered?: { [page: string]: boolean };
  vasCounter: number;
  productCounter: number;
  vasTriggeredPages: { [page: string]: boolean };
  productTriggeredPages: { [page: string]: boolean };
};

export enum ChatbotActionTypes {
  SET_CHATBOT_STATUS = 'chatbot/set-status',
  SET_CHATBOT_TRIGGER_TYPE = 'chatbot/set-trigger-type',
  SET_PROACTIVE_MODAL_VIEWED_PAGE = 'chatbot/set-proactive-modal-viewed-page',
  SET_GIGA_EVENT_TRIGGERED_PAGE = 'chatbot/set-giga-event-triggered-page',
  INCREMENT_VAS_COUNTER = 'chatbot/increment-vas-counter',
  INCREMENT_PRODUCT_COUNTER = 'chatbot/increment-product-counter',
  MARK_VAS_TRIGGERED_PAGE = 'chatbot/mark-vas-triggered-page',
  MARK_PRODUCT_TRIGGERED_PAGE = 'chatbot/mark-product-triggered-page',
}

export interface SetChatbotStatusAction {
  type: ChatbotActionTypes.SET_CHATBOT_STATUS;
  status: ChatbotState['status'];
}

export interface SetChatbotTriggerTypeAction {
  type: ChatbotActionTypes.SET_CHATBOT_TRIGGER_TYPE;
  triggerType: ChatbotState['triggerType'];
}

export interface SetProactiveModalViewedPageAction {
  type: ChatbotActionTypes.SET_PROACTIVE_MODAL_VIEWED_PAGE;
  page: string;
  viewed: boolean;
}

export interface SetGigaEventTriggeredPageAction {
  type: ChatbotActionTypes.SET_GIGA_EVENT_TRIGGERED_PAGE;
  page: string;
  viewed: boolean;
}

export interface IncrementVasCounterAction {
  type: ChatbotActionTypes.INCREMENT_VAS_COUNTER;
}

export interface IncrementProductCounterAction {
  type: ChatbotActionTypes.INCREMENT_PRODUCT_COUNTER;
}

export interface MarkVasTriggeredPageAction {
  type: ChatbotActionTypes.MARK_VAS_TRIGGERED_PAGE;
  page: string;
}

export interface MarkProductTriggeredPageAction {
  type: ChatbotActionTypes.MARK_PRODUCT_TRIGGERED_PAGE;
  page: string;
}

export type ChatbotActions =
  | SetChatbotStatusAction
  | SetChatbotTriggerTypeAction
  | SetProactiveModalViewedPageAction
  | SetGigaEventTriggeredPageAction
  | IncrementVasCounterAction
  | IncrementProductCounterAction
  | MarkVasTriggeredPageAction
  | MarkProductTriggeredPageAction;
